import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export const SectionCard = ({
  title,
  subtitle,
  action,
  children,
  className,
  testid,
  accent,
  eyebrow,
  icon: Icon,
  to,
  ariaLabel,
}) => {
  const c = accent || "var(--accent-primary)";
  const clickable = !!to;
  return (
    <section
      data-testid={testid || "section-card"}
      className={cn(
        "relative overflow-hidden rounded-2xl border border-[#E4E9F3] bg-white shadow-[0_2px_12px_rgba(20,36,95,0.05)]",
        clickable &&
          "transition-all duration-200 hover:-translate-y-0.5 hover:border-[#C7D2FE] hover:shadow-[0_10px_28px_rgba(20,36,95,0.12)] focus-within:ring-2 focus-within:ring-[#1D4ED8]/50 focus-within:ring-offset-2",
        className
      )}
    >
      {clickable && (
        <Link
          to={to}
          data-testid={testid ? `${testid}-link` : undefined}
          aria-label={ariaLabel || (title ? `View ${title}` : "View")}
          className="absolute inset-0 z-[2] rounded-2xl focus:outline-none"
        />
      )}
      <span className="absolute inset-x-0 top-0 h-1" style={{ backgroundColor: c }} />
      {(title || action || eyebrow) && (
        <div className="flex items-center justify-between gap-4 border-b border-[#EEF2FB] px-6 py-4">
          <div className="flex items-center gap-3">
            {Icon ? (
              <span
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl text-white shadow-sm"
                style={{ backgroundColor: c }}
              >
                <Icon size={18} strokeWidth={2.2} />
              </span>
            ) : (
              <span className="h-8 w-1.5 shrink-0 rounded-full" style={{ backgroundColor: c }} />
            )}
            <div>
              {eyebrow && (
                <p
                  className="text-[10px] font-bold uppercase tracking-[0.18em]"
                  style={{ color: c }}
                >
                  {eyebrow}
                </p>
              )}
              {title && (
                <h3 className="font-heading text-lg font-semibold tracking-tight text-[#14245F]">
                  {title}
                </h3>
              )}
              {subtitle && <p className="mt-0.5 text-sm text-[#5A6B8C]">{subtitle}</p>}
            </div>
          </div>
          {action && <div className="relative z-[3]">{action}</div>}
        </div>
      )}
      <div className="p-6">{children}</div>
    </section>
  );
};
